module.exports = __webpack_public_path__ + "img/40_1.b3cbb633.jpg";